import React, { createContext, useCallback, useMemo, useState } from 'react';
import { Data } from '../data/Data';
import { useLotsCommerciaux } from './lotCommercialContext';
import { useNotificationsManager } from './notificationContext';

const LotContext = createContext();
const LotManagerContext = createContext();

export const LotContextProvider = ({ children }) => {

    const { dismiss, extractErrorMessages, inform } = useNotificationsManager();
    const { idOperationActive, idLotCommercialActif } = useLotsCommerciaux();

    const [allLots, setAllLots] = useState([]);
    const [loaded, setLoaded] = useState([]);

    const loadLots = useCallback((idOperation, idLotCommercial) => {
        const id = inform("Chargement des lots...");

        Data._getLots(idOperation, idLotCommercial).then(response => {
            if (response.codeRetour === 0) {
                const objet = response.reponseAPIobjet;
                let lots = objet.lots || [];
                setAllLots(prevLots => {
                    const merged = [...prevLots, ...lots];
                    return merged;
                });
                setLoaded(prevLoadedIdOperations => [...prevLoadedIdOperations, { idOperation, idLotCommercial }]);
            }
            else extractErrorMessages(response);

            dismiss(id);
        });
    }, [dismiss, extractErrorMessages, inform]);

    const lots = useMemo(() => {
        if (!idOperationActive || !idLotCommercialActif) return [];
        const alreadyLoaded = loaded.some(item => item.idOperation === idOperationActive && item.idLotCommercial === idLotCommercialActif);
        if (!alreadyLoaded) {
            loadLots(idOperationActive, idLotCommercialActif);
            return [];
        }
        else return allLots.filter(lot => lot.idOperation === idOperationActive && lot.idLotCommercial === idLotCommercialActif);
    }, [allLots, idOperationActive, idLotCommercialActif, loadLots, loaded]);

    const resetLots = useCallback(() => {
        setAllLots([]);
        setLoaded([]);
    }, []);

    const value = useMemo(
        () => ({ lots }),
        [lots]
    );

    const managerValue = useMemo(
        () => ({ resetLots }),
        [resetLots]
    );

    return <LotManagerContext.Provider value={managerValue}>
        <LotContext.Provider value={value}>
            {children}
        </LotContext.Provider>
    </LotManagerContext.Provider>;

};

export const useLots = () => {
    const data = React.useContext(LotContext);
    if (data === undefined) throw new Error();
    const { lots } = data;
    return { lots };
};

export const useLotsManager = () => {
    const manager = React.useContext(LotManagerContext);
    if (manager === undefined) throw new Error();
    const { resetLots } = manager;
    return { resetLots };
};